import { asAmount, asCouponPayment, asMakeWholeCallSpreadBps, Currency, Money } from "@goodfill/domain-properties";
import Decimal from "decimal.js";
import { z } from "zod";
import { zDecimal } from "./zodDecimal";
import { zAmount } from "./zodMoney";

export const zISIN = z.string().length(12, { message: "ISIN must be 12 characters" });
export const zCUSIP = z.string().length(9, { message: "CUSIP must be 9 characters" });

export const zMinimumPieceEnumToMoney = (currency: Currency) =>
  z
    .union([z.literal("1000"), z.literal("2000")])
    .transform((a): Money => ({ amount: asAmount(new Decimal(a)), currency }));

export const zAmountToMoney = (currency: Currency, message: string = "number required") =>
  zAmount(message).transform((a): Money => ({ amount: a, currency }));

export const zCouponPaymentToPercents = (message: string = "number required") =>
  zDecimal({ errorMessages: { invalid: message } }).transform((a) => asCouponPayment(a.div(100)));

export const zCouponPayment = (message: string = "number required") =>
  zDecimal({ errorMessages: { invalid: message } }).transform((a) => asCouponPayment(a));

export const zMakeWholeCallEmptyStringToNull = () =>
  z
    .preprocess(
      (a) => (a === "" ? null : String(Number(a)) === a ? Number(a) : a),
      z.union([z.null(), z.number().min(0)]),
    )
    .transform((a) => (a === null ? null : asMakeWholeCallSpreadBps(a)));
